<span
  [matTooltip]="text() ? text() : ('page.items.label.unassigned' | translate)"
  class="avatar-circle"
  [ngClass]="{ dashed: !text() }"
>
  <span *ngIf="text()">{{ text()! | nameInitials }}</span>
  <mat-icon *ngIf="!text()">person</mat-icon>
</span>
